<template>
    <div>
        <div class="container" v-if="pageWidth>1000">
            <div class="content">
                <div class="logo" @click="activeChange(1)">
                    <img src="@/assets/logo.png">
                </div>
                <div class="menu">
                    <div @click="activeChange(1)"><p>首页</p><i :class="[key===1?'active':'']"></i></div>
                    <div @click="activeChange(2)"><p>关于我们</p><i :class="[key===2?'active':'']"></i></div>
                    <div class="solution">
                        <p>解决方案</p><i :class="[key===3?'active':'']"></i>
                        <div class="list">
                            <p @click="activeChange(3.1)">低空频谱监测平台</p>
                            <p @click="activeChange(3.2)">频谱测绘系统</p>
                            <p @click="activeChange(3.6)">非法辐射源定位系统</p>
                            <p @click="activeChange(3.3)">牧星反无监测系统</p>
                            <p @click="activeChange(3.4)">多模认知通讯系统</p>
                            <p @click="activeChange(3.7)">抗干扰无人机系统</p>
                            <p @click="activeChange(3.5)">星筑IBOS系统</p>
                        </div>
                    </div>
<!--                    <div class="product">-->
<!--                        <p>产品系列</p><i :class="[key===4?'active':'']"></i>-->
<!--                        <div class="list">-->
<!--                            <p @click="activeChange(4.1)">频谱测绘系统</p>-->
<!--                            <p @click="activeChange(4.2)">牧星反无监测系统</p>-->
<!--                            <p @click="activeChange(4.2)">多模认知通讯系统</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div @click="activeChange(4)"><p>产品系列</p><i :class="[key===4?'active':'']"></i></div>-->
                    <div @click="activeChange(5)"><p>人力资源</p><i :class="[key===5?'active':'']"></i></div>
                    <div @click="activeChange(6)"><p>联系我们</p><i :class="[key===6?'active':'']"></i></div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="content">
                <div>
                    <div class="button">
                        <a-icon type="menu-fold" @click="onClose" v-if="visible"/>
                        <a-icon type="menu-unfold" @click="showDrawer" v-else/>
                    </div>
                    <a-drawer
                        title="Basic Drawer"
                        placement="left"
                        :closable="false"
                        :visible="visible"
                        @close="onClose"
                        width="200px"
                    >
                        <div>
                            <a-menu
                                style="width: 200px"
                                :default-selected-keys="['1']"
                                :open-keys.sync="openKeys"
                                mode="inline"
                                @click="handleClick"
                            >
                                <a-menu-item @click="activeChange(1)" key="1">
                                    首页
                                </a-menu-item>
                                <a-menu-item @click="activeChange(2)" key="2">
                                    关于我们
                                </a-menu-item>
                                <a-sub-menu key="sub2" @titleClick="titleClick">
                                    <span slot="title">解决方案</span>
                                    <a-menu-item key="3.1" @click="activeChange(3.1)">
                                        低空频谱监测平台
                                    </a-menu-item>
                                    <a-menu-item key="3.2" @click="activeChange(3.2)">
                                        频谱测绘系统
                                    </a-menu-item>
                                    <a-menu-item key="3.6" @click="activeChange(3.6)">
                                        非法辐射源定位系统
                                    </a-menu-item>
                                    <a-menu-item key="3.3" @click="activeChange(3.3)">
                                        牧星反无监测系统
                                    </a-menu-item>
                                    <a-menu-item key="3.4" @click="activeChange(3.4)">
                                        多模认知通讯系统
                                    </a-menu-item>
                                    <a-menu-item key="3.7" @click="activeChange(3.7)">
                                        抗干扰无人机系统
                                    </a-menu-item>
                                    <a-menu-item key="3.5" @click="activeChange(3.5)">
                                        星筑IBOS系统
                                    </a-menu-item>
                                </a-sub-menu>
<!--                                <a-menu-item @click="activeChange(4)" key="5">-->
<!--                                    新闻中心-->
<!--                                </a-menu-item>-->
                                <a-menu-item @click="activeChange(5)" key="6">
                                    人力资源
                                </a-menu-item>
                                <a-menu-item @click="activeChange(6)" key="7">
                                    联系我们
                                </a-menu-item>
                            </a-menu>
                        </div>
                    </a-drawer>
                </div>
                <div class="logo" @click="activeChange(1)">
                    <img src="@/assets/logo.png">
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: "MHeader",
    computed: {
        ...mapState(['activeMenuKey'])
    },
    data() {
        return {
            key: sessionStorage.getItem('key') ? Number(sessionStorage.getItem('key')) : 1,
            pageWidth: window.innerWidth,
            visible: false,
            current: ['mail'],
            openKeys: ['sub1'],
        }
    },
    watch: {
        openKeys(val) {
            console.log('openKeys', val);
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$watch('$route', (to, from) => {
            this.key = Number(sessionStorage.getItem('key'))
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        toPage(path) {
            this.$router.push({path: path}).catch(err => {
            })
        },
        activeChange(index, value) {
            this.key = index
            sessionStorage.setItem('key', this.key);
            switch (this.key) {
                case 1:
                    this.toPage('/index.html')
                    break
                case 2:
                    this.toPage('/about.html')
                    break
                case 3.1:
                    this.toPage('/monitor.html')
                    break
                case 3.2:
                    this.toPage('/mapping.html')
                    break
                case 3.3:
                    this.toPage('/fanwu.html')
                    break
                case 3.4:
                    this.toPage('/xingzhi-u1.html')
                    break
                case 3.5:
                    this.toPage('/ibos.html')
                    break
                case 3.6:
                    this.toPage('/direction-finding.html')
                    break
                case 3.7:
                    this.toPage('/uav.html')
                    break
                case 4.1:
                    this.toPage('/product.html')
                    break
                case 5:
                    this.toPage('/talent.html')
                    break
                case 6:
                    this.toPage('/contactUs.html')
                    break
            }
        },
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
        handleClick(e) {
            console.log('click', e);
        },
        titleClick(e) {
            console.log('titleClick', e);
        },
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped lang="less">
@import "../styles/mHeader";

.menu {
    .solution {
        position: relative;

        .list {
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
            padding: 8px 0;
            width: 160px;
            height: 300px;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
            z-index: 1000;

            p {
                width: 100%;
                box-sizing: border-box;
                padding: 10px 20px;
                margin: 0;
                color: #333;
                font-size: 14px;
                line-height: 1.4;
                white-space: nowrap;
                transition: all 0.2s ease;
                cursor: pointer;
                position: relative;
                text-align: left;

                &:hover {
                    color: #1890ff;
                    background: #f8f9fa;
                    cursor: pointer;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 3px;
                        height: 100%;
                        background: #1890ff;
                    }
                }
            }
        }

        &:hover {
            .list {
                opacity: 1;
                visibility: visible;
                top: calc(100% + 5px);
            }

            > p {
                color: #1890ff;
            }
        }

        // 下拉箭头
        > p {
            position: relative;
            padding-right: 15px;

            &::after {
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 4px solid currentColor;
                transform: translateY(-50%);
            }
        }

        // 添加小三角指示器
        .list::before {
            content: '';
            position: absolute;
            top: -6px;
            left: 50%;
            transform: translateX(-50%);
            border-width: 0 6px 6px;
            border-style: solid;
            border-color: transparent transparent #fff;
            filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.05));
        }
    }
}

// 确保移动端样式不受影响
@media screen and (max-width: 1000px) {
    .menu {
        .solution {
            .list {
                display: none;
            }
        }
    }
}
</style>
